import React from 'react';
import { TextField, Dropdown, PrimaryButton, DefaultButton, IconButton, Icon, Stack, Label, Modal, Checkbox, ChoiceGroup, mergeStyleSets, CommandBarButton, FontWeights, FontIcon, TooltipHost, DirectionalHint, ComboBox, Link, Persona, PersonaSize, MessageBar, MessageBarType } from 'office-ui-fabric-react';
import ProfileRuleSettings from './ProfileRuleSettings';
import { beakLeftOverIcon } from '../common/tooltipBeak';
import RuleCard from './RuleCard';
import { MyContext } from '../../context';
import { mutationCreateUserProfile, mutationUpdateUserProfile, queryGetConfigData, mutationDeleteUserProfile, queryGetTimezonesList, getProfileRule } from '../../queries/querySettings';
import './RecordingProfiles.scss';
import { toast } from 'react-toastify';
import UploadAnnouncement from "../RuleSetter/UploadAnnouncement";
import NumberPrefix from "../RuleSetter/RuleList/NumberPrefix";
import {
    checkDefaultCustomAnnouncement,
    getAnnouncementsWithoutDefault,
    getDefaultAnnouncements,
    getSecondsFromTimeString,
    getTimeStringFromSeconds,
    doesProfileNameExist
} from "./ProfileRuleHelpers";
import UserPicker from '../ReportView/ReportConfiguration/UserPicker';
import { TeachingBubble } from 'office-ui-fabric-react';

const classNames = mergeStyleSets({
    flexContainer: {
        display: "flex",
        alignItems: "center",
    },

    marginBottom: {
        marginBottom: "7px",
    },
    numberInput: {
        width: "55px",
    },
    marginTop: {
        marginTop: "10px",
    },

    listContent: {
        flex: '4 4 auto',
        padding: '0 24px 24px 24px',
        overflowY: 'hidden',
        selectors: {
            p: {
                margin: '14px 0',
            },
            'p:first-child': {
                marginTop: 0,
            },
            'p:last-child': {
                marginBottom: 0,
            },
        },
    },
    userList: {
        display: "inline-block",
        margin: "2px"
    },
    userNameAlign: {
        'vertical-align': 'sub',
        display: 'inline-block',
        'line-height': 'normal',
        'margin-left': '5px',
        'text-overflow': 'ellipsis'

    },
    groupList: {
        margin: "2px"
    },
    iconButtonStyles: {
        marginLeft: 'auto',
        marginTop: '4px',
        marginRight: '2px',
    },
    listStyles: {
        padding: '20px',
        height: '100%'
    },
    listHeader: [
        {
            flex: '1 1 auto',
            borderTop: '4px solid blue',
            // color: theme.palette.neutralPrimary,
            display: 'flex',
            // fontSize: FontSizes.xLarge,
            alignItems: 'center',
            // fontWeight: FontWeights.semibold,
            padding: '12px 12px 14px 24px',
        },
    ],

});

const styles = {
    root: {
        paddingTop: "20px",
    },
};
class ProfileSettings extends React.Component {
    constructor(props) {
        super(props);
        const profileData = this.props.profileData || {};
        const rules = profileData.rules ? this.mapRuleIdsToObjects(profileData.rules, this.props.profileRulesData) : [];
        let denyListUsers = [];
        let denyListUsersSource = profileData?.chatTypeDenyList ? profileData?.chatTypeDenyList.split(',') : "";
        for (let x = 0; x < denyListUsersSource.length; x++) {
            denyListUsers.push({
                userId: denyListUsersSource[x],
                key: denyListUsersSource[x]
            });
        }
        this.tmpUserUsage = [];
        this.displayUsers = [];
        this.tmpGroupUsage = [];
        this.displayGroups = [];
        if (this.props.dataUsers != null) {
            for (let x = 0; x < this.props.dataUsers.length; x++) {
                if (profileData != null && this.props.dataUsers[x].groupId == null) {
                    if ((this.props.dataUsers[x].recordingRules != null && this.props.dataUsers[x].recordingRules.includes(profileData?.id))) {
                        this.tmpUserUsage.push(this.props.dataUsers[x].userId);
                        this.displayUsers.push({ "userid": this.props.dataUsers[x].userId, "name": this.props.dataUsers[x].name });
                    }
                }
            }
        }

        if (this.props.dataGroups != null) {
            for (let x = 0; x < this.props.dataGroups.length; x++) {
                if (this.props.data != null) {
                    if ((this.props.dataGroups[x].recordingRules != null && this.props.dataGroups[x].recordingRules.includes(profileData?.id))) {
                        this.tmpGroupUsage.push(this.props.dataGroups[x].name);
                        this.displayGroups.push({ "id": this.props.dataGroups[x].id, "name": this.props.dataGroups[x].name });
                    }
                }
            }
        }

        this.state = {
            id: profileData.id || null,
            name: profileData.name || "",
            tenantId: profileData.tenantId || null,
            rules: rules,
            selectedRule: null,
            isModalOpen: false,
            graphqlPending: false,
            recReevaluateChangeFromOneToOneToMeeting: profileData?.recReevaluateChangeFromOneToOneToMeeting || false, // used for reevaluate the call when it changes from 1:1 to meeting
            disableNextRecording: profileData?.disableNextRecording || false, // used for disable recording once
            disableNextRecordingReasonRequired: profileData?.disableNextRecordingReasonRequired || false, // used for disable recording reason required checkbox
            disableNextRecordingReasons: profileData?.disableNextRecordingReasons || "", // used for disable recording reasons
            disableNextRecordingReasonsPlaceholder: "", // used just for for disable recording reasons placeholder
            userStreamOnly: profileData?.userStreamOnly || false, // used for record user stream only
            useOnBehalfOfUserSetting: profileData?.useOnBehalfOfUserSetting || false, // used for multiline support MSFT delegation
            callQueueRuleOverride: profileData?.callQueueRuleOverride || false, // used for CR call queue rule override
            hasDtmfSettings: profileData?.hasDtmfSettings || false, // used for DTMF Settings checkbox(not in original rules)
            isDtmfEnabled: profileData?.isDtmfEnabled || false, // used for rod control via dtmf
            rodDmtfSTart: profileData?.start || '', // used for rod start code ->graph is start
            rodDmtfStop: profileData?.stop || '', // used for rod stop code ->graph is stop
            isDtmfAnnouncementSuppressionEnabled: profileData?.isDtmfAnnouncementSuppressionEnabled || false, // used for DTMF announcement suppression
            announcementSuppressionCode: profileData?.announcementSuppressionCode || '', // used for DTMF announcement suppression code
            announcementSuppressionTimeInDays: profileData?.announcementSuppressionTimeInDays || 0, // used for DTMF announcement suppression time in days
            chat: profileData?.chat || false, // used for chat recording checkbox
            chatType: profileData?.chatType || 'Bulk', // used for pure chat conversations never/bulk/external
            channelType: profileData?.channelType || 'Never', // used for chat in channel never/bulk/selected channels
            announcementInChat: false, // used for announcement in chat checkbox(not in original rules) ===> profileData.announcementInChat 
            chatTypeDeny: profileData?.chatTypeDeny || false,
            chatTypeDenyList: denyListUsers,
            chatTtl: profileData?.chatTtl
                ? profileData.chatTtl
                : (this.props.userRules?.license === "13" ? 180 : 720), // used for chat ttl in days            internalParticipants: profileData?.internalParticipants || false, // used for internal participants checkbox(not in original rules)
            externalParticipants: profileData?.externalParticipants || false, // used for external participants checkbox(not in original rules)
            selectedChannel: profileData?.selectedChannel || false, // used for selected channels checkbox(not in original rules)
            channelList: profileData?.channelList || '', // used for chat in channel selected channels team names
            mail: profileData?.mail || false, // used for mail recording checkbox
            mailTtl: profileData?.mailTtl ?? 720, // used for mail ttl in days
            description: profileData?.text || "", // used for description ->in graph is text,
            updated: false,
            isFormValid: false, 
            ruleFromProfile: false,
            selectedRuleToEdit: [],
            announcementSetting: profileData?.announcementSetting || "DefaultMsft",
            announcementType: profileData?.announcementType || "DefaultAnnouncement",
            announcements: profileData?.announcements ? getAnnouncementsWithoutDefault(profileData?.announcements) : [],
            beepToneDelay: profileData?.beepToneDelay ? profileData?.beepToneDelay : 5,
            enableBeepTone: profileData?.enableBeepTone || false,
            defaultCustomAnnouncement: profileData?.announcements ? checkDefaultCustomAnnouncement(profileData?.announcements) : false,
            deletedFilesFromAnnouncements: [],
            defaultAnnouncement: profileData?.announcements
                ? getDefaultAnnouncements(profileData?.announcements)
                : {
                    prefixList: ["default"],
                    start: "",
                    stop: "",
                },
            numberPrefixIndex: profileData?.announcements ? profileData?.announcements.length : 0,
            timezone: profileData?.timezone || "",
            timezonesList: [],
            trackOnDemandDecision: profileData?.trackOnDemandDecision || false,
            ruleDecisionTracking: profileData?.ruleDecisionTracking || false,
            timezoneRequired: false,
            modalDisplay: "",
            showModal: false,
            channelListError: "",
            chatTypeDenyListError: "",
            nameError: "",
            showDeleteConfirm: false,
            recordSeparateSpeakers: profileData?.recordSeparateSpeakers || false,

            // Keep/Delete warning related
            hasKeepDeleteRule: false,
            hasNoKeepDeleteRule: false,
            showKeepDeleteConfirm: false,
            isEntryVoiceOnly: profileData?.isEntryVoiceOnly || false
        };
    }
    async componentDidMount() {
        const timezonesList = await this.getTimezonesList();
        this.setState({ timezonesList }, this.validateForm);
    }

    componentDidUpdate(prevProps, prevState) {
        if (
            prevProps.profileRulesData !== this.props.profileRulesData ||
            prevState.rules !== this.state.rules
        ) {
            const updatedRules = this.state.rules.map(rule => {
                if (rule && rule.id) {
                    const found = (this.props.profileRulesData || []).find(r => r.id === rule.id);
                    return found ? found : rule;
                }
                // If rule has no id (is new), keep it like this
                return rule;
            });
            // Only update if the rules actually differ
            const rulesChanged = JSON.stringify(updatedRules) !== JSON.stringify(this.state.rules);
            if (rulesChanged) {
                this.setState({ rules: updatedRules });
            }
        }
        // Keep/Delete warning logic
        if (prevState.rules !== this.state.rules) {
            this.setState({
                hasKeepDeleteRule: this.state.rules.some(rule => rule?.filters?.recordingType?.hasKeepDelete),
                hasNoKeepDeleteRule: this.state.rules.some(rule => !rule?.filters?.recordingType?.hasKeepDelete)
            })
        }
    }


    _openModal = (modalDisplay) => {
        this.setState({ showModal: true, modalDisplay: modalDisplay });


    }
    _closeModal = () => {
        this.setState({ showModal: false });
    }
    getTimezonesList = async () => {

        try {
            const response = await this.props.apol.query({
                query: queryGetTimezonesList,
                variables: { auth: this.props.authorization },
            });
            return response?.data?.getTimezonesList || [];
        } catch (error) {
            console.error("Error fetching timezones:", error);
            return [];
        }
    }

    fetchProfileRuleById = async (ruleId) => {
        try {
            const { data } = await this.props.apol.query({
                query: getProfileRule,
                variables: {
                    auth: this.props.authorization,
                    id: ruleId,
                },
            });
            return data.getProfileRule;
        } catch (error) {
            console.error('Error fetching profile rule:', error);
            return null;
        }
    };

    //will beed to add correct data after we see what we get from graph rules
    mapRuleIdsToObjects(ruleIds, ruleData) {
        return ruleIds.map(id => {
            const rule = ruleData.find(rule => rule.id === id);
            return rule ? rule : [];
        });
    }

    moveRule = (index, direction) => {
        const newRules = [...this.state.rules];
        const [movedRule] = newRules.splice(index, 1);
        newRules.splice(index + direction, 0, movedRule);
        this.setState({ rules: newRules, updated: true }, this.validateForm);
    };

    deleteRule = (index) => {
        const newRules = this.state.rules.filter((_, i) => i !== index);
        const deletedRuleId = this.state.rules[index]?.id;
        this.setState(prevState => ({
            rules: newRules,
            selectedRule: prevState.selectedRule === deletedRuleId ? null : prevState.selectedRule,
            updated: true
        }), this.validateForm);
    };

    openModalRule = async (ruleId = null) => {
        if (ruleId) {
            const ruleToEdit = await this.fetchProfileRuleById(ruleId);
            this.setState({ isModalOpen: true, ruleFromProfile: true, selectedRuleToEdit: ruleToEdit });
        } else {
            this.setState({ isModalOpen: true, ruleFromProfile: true, selectedRuleToEdit: [] });
        }
    };

    closeModal = () => {
        this.setState({ isModalOpen: false });
    };

    handleCheckboxChange = (event, isChecked) => {
        const { name } = event.target;
        this.setState({ [name]: isChecked, updated: true }, this.validateForm);
    };

    handleRadioChange = (event, option) => {
        const { name } = event.target;
        this.setState({ [name]: option.key, updated: true }, this.validateForm);
    };
    handleInputChange = (event) => {
        const { name, value } = event.target;
        this.setState({ [name]: value, updated: true }, this.validateForm);
    };

    _validateDTMFCode = (str) => {
        if (str === "") {
            return "dtmfFieldEmpty";
        }
        for (let i = 0; i < str.length; i++) {
            if (!((str[i] >= "0" && str[i] <= "9") || str[i] === "*" || str[i] === "#")) {
                return "dtmfInvalidChars";
            }
        }
        return "";
    };

    _getDtmfValidationErrors = (state) => {
        let rodDmtfStartError = "";
        let rodDmtfStopError = "";
        let announcementSuppressionCodeError = "";
        let announcementSuppressionDaysError = "";

        if (state.hasDtmfSettings && state.isDtmfEnabled) {
            rodDmtfStartError = this._validateDTMFCode(state.rodDmtfSTart);
            rodDmtfStopError = this._validateDTMFCode(state.rodDmtfStop);

            if (state.rodDmtfSTart && state.rodDmtfStop && state.rodDmtfSTart === state.rodDmtfStop) {
                rodDmtfStartError = "dtmfStartStopIdentical";
                rodDmtfStopError = "dtmfStartStopIdentical";
            }
        }

        if (state.hasDtmfSettings && state.isDtmfAnnouncementSuppressionEnabled) {
            announcementSuppressionCodeError = this._validateDTMFCode(state.announcementSuppressionCode);
            if (!announcementSuppressionCodeError && !state.announcementSuppressionCode) {
                announcementSuppressionCodeError = "dtmfSuppressionRequired";
            }
            if (
                state.announcementSuppressionTimeInDays === 0 ||
                state.announcementSuppressionTimeInDays === undefined ||
                state.announcementSuppressionTimeInDays === null
            ) {
                announcementSuppressionDaysError = "dtmfSuppressionDaysRequired";
            }
        }

        return {
            rodDmtfStartError,
            rodDmtfStopError,
            announcementSuppressionCodeError,
            announcementSuppressionDaysError
        };
    };

    _getDisableNextRecordingReasonsError = (state) => {
        if (!state.disableNextRecording || !state.disableNextRecordingReasonRequired) {
            return "";
        }
        const reasons = (state.disableNextRecordingReasons || "").split("|").map(r => r.trim()).filter(r => r.length > 0);
        if (reasons.length === 0) {
            return "stopReasonsRequired";
        }
        if (reasons.length > 10) {
            return "maxLimitReasons";
        }
        return "";
    };

    hasAnnouncementValidationError = () => {
        if (
            this.state.announcementSetting === "PstnAnnouncement" &&
            this.state.announcementType === "CustomAnnouncement"
        ) {
            for (let i = 0; i < this.state.announcements.length; i++) {
                const ann = this.state.announcements[i];
                if (!ann.start || !ann.stop) {
                    return true;
                }
            }
            if (this.state.defaultCustomAnnouncement) {
                const defAnn = this.state.defaultAnnouncement;
                if (!defAnn.start || !defAnn.stop) {
                    return true;
                }
            }
        }
        return false;
    };

    validateForm = () => {
        // Check if any rule requires a timezone
        const timezoneRequired = this.state.rules.some(rule => {
            const timetable = rule?.filters?.schedulingFilter?.timetable;
            return timetable && (
                timetable.daily != null ||
                timetable.monthly != null ||
                timetable.weekly != null
            );
        });


        // Channel list validation
        let channelListError = "";
        if (this.state.selectedChannel && (!this.state.channelList || this.state.channelList.trim() === "")) {
            channelListError = "channelListRequired";
        }

        // ChatTypeDeny list validation
        let chatTypeDenyListError = "";
        if (this.state.chatTypeDeny && (!this.state.chatTypeDenyList || this.state.chatTypeDenyList.length === 0)) {
            chatTypeDenyListError = "chatTypeDenyListRequired";
        }

        // Duplicate profile name validation
        const profilesList = this.props.profilesList || [];
        const nameExists = doesProfileNameExist(
            profilesList.filter(p => p.id !== this.state.id),
            this.state.name
        );
        let nameError = "";
        if (nameExists) {
            nameError = "nameUsed";
        }

        //invalid chatTTl
        let chatTtlValid = true;
        if (this.state.chat) {
            if (
                this.state.chatTtl === undefined
                || this.state.chatTtl === null
                || isNaN(this.state.chatTtl)
                || this.state.chatTtl < 1
                || (this.props.userRules?.license === "13" && this.state.chatTtl > 180)
            ) {
                chatTtlValid = false;
            }
        }

        //invalid mailTtl
        let mailTtlValid = true;
        if (this.state.mail) {
            if (
                this.state.mailTtl === undefined
                || this.state.mailTtl === null
                || isNaN(this.state.mailTtl)
                || this.state.mailTtl < 1
            ) {
                mailTtlValid = false;
            }
        }


        // Use the helper for DTMF/suppression validation
        const dtmfErrors = this._getDtmfValidationErrors(this.state);

        // Validate disableNextRecordingReasons
        const disableNextRecordingReasonsError = this._getDisableNextRecordingReasonsError(this.state);

        const isFormValid =
            this.state.name.trim() !== "" &&
            !nameError &&
            (!timezoneRequired || (this.state.timezone && this.state.timezone !== "")) &&
            !this.hasAnnouncementValidationError() &&
            !dtmfErrors.rodDmtfStartError &&
            !dtmfErrors.rodDmtfStopError &&
            !dtmfErrors.announcementSuppressionCodeError &&
            !dtmfErrors.announcementSuppressionDaysError &&
            !disableNextRecordingReasonsError &&
            !channelListError &&
            !chatTypeDenyListError &&
            chatTtlValid &&
            mailTtlValid;

        this._dtmfErrors = dtmfErrors;
        this._disableNextRecordingReasonsError = disableNextRecordingReasonsError;

        this.setState({
            isFormValid,
            timezoneRequired,
            channelListError,
            chatTypeDenyListError,
            nameError
        });
    };

    updateState = (key, value) => {
        this.setState(
            (prevState) => ({
                ...prevState,
                [key]: value,
                updated: true,
            }),
            this.validateForm
        );
    };
    handleSave = async () => {
        const { apol, authorization } = this.props;
        this.setState({ graphqlPending: true });
        let disableNextRecordingReasonsList = "";
        if (this.state.disableNextRecordingReasons !== null && this.state.disableNextRecordingReasonRequired) {
            disableNextRecordingReasonsList = this.state.disableNextRecordingReasons.replace(/\s*\|\s*/g, '|')
        }

        let chatDenyList = "";
        for (let y = 0; y < this.state.chatTypeDenyList.length; y++) {
            if (y !== 0)
                chatDenyList += ",";
            chatDenyList += this.state.chatTypeDenyList[y].key;

        };
        const profile = {
            id: this.state.id,
            name: this.state.name,
            tenantId: this.props.tenantId,
            rules: this.state.rules.map(rule => rule.id), // Only send rule IDs
            recReevaluateChangeFromOneToOneToMeeting: this.state.recReevaluateChangeFromOneToOneToMeeting,
            disableNextRecording: this.state.disableNextRecording,
            disableNextRecordingReasonRequired: this.state.disableNextRecordingReasonRequired,
            disableNextRecordingReasons: disableNextRecordingReasonsList,
            userStreamOnly: this.state.userStreamOnly,
            useOnBehalfOfUserSetting: this.state.useOnBehalfOfUserSetting,
            callQueueRuleOverride: this.state.callQueueRuleOverride,
            hasDtmfSettings: this.state.hasDtmfSettings,
            isDtmfEnabled: this.state.isDtmfEnabled,
            start: this.state.rodDmtfSTart,
            stop: this.state.rodDmtfStop,
            isDtmfAnnouncementSuppressionEnabled: this.state.isDtmfAnnouncementSuppressionEnabled,
            announcementSuppressionCode: this.state.announcementSuppressionCode,
            announcementSuppressionTimeInDays: this.state.announcementSuppressionTimeInDays,
            chat: this.state.chat,
            chatType: this.state.chatType,
            channelType: this.state.channelType,
            announcementInChat: this.state.announcementInChat,
            chatTypeDeny: this.state.chatTypeDeny,
            chatTypeDenyList: chatDenyList,
            chatTtl: this.state.chatTtl,
            mail: this.state.mail,
            mailTtl: this.state.mailTtl,
            internalParticipants: this.state.internalParticipants,
            externalParticipants: this.state.externalParticipants,
            selectedChannel: this.state.selectedChannel,
            channelList: this.state.channelList,
            text: this.state.description,
            announcements: this.state.defaultCustomAnnouncement ? this.state.announcements.concat(this.state.defaultAnnouncement) : this.state.announcements,
            announcementSetting: this.state.announcementSetting,
            announcementType: this.state.announcementType,
            enableBeepTone: this.state.enableBeepTone,
            beepToneDelay: this.state.beepToneDelay,
            timezone: this.state.timezone || "",
            trackOnDemandDecision: this.state.trackOnDemandDecision,
            recordSeparateSpeakers: this.state.recordSeparateSpeakers,
            isEntryVoiceOnly: this.state.isEntryVoiceOnly,
            ruleDecisionTracking: this.state.ruleDecisionTracking,

        };

        try {
            if (profile.id) {
                const response = await apol.mutate({
                    mutation: mutationUpdateUserProfile,
                    refetchQueries: [{
                        query: queryGetConfigData,
                        variables: { auth: authorization },
                    }],
                    variables: {
                        input: authorization,
                        profile,
                    },
                });
                toast.success('Profile updated', {
                    position: "bottom-left",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                });
            } else {
                const response = await apol.mutate({
                    mutation: mutationCreateUserProfile,
                    refetchQueries: [{
                        query: queryGetConfigData,
                        variables: { auth: authorization },
                    }],
                    variables: {
                        input: authorization,
                        profile,
                    },
                });
                console.log(response);
                toast.success('Profile created', {
                    position: "bottom-left",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                });
            }
        } catch (error) {
            toast.error('Error saving profile', {
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
        }
        setTimeout(() => this.setState({ graphqlPending: false }), 1000);

        this.props.closePanel();
    };

    deleteProfile = async () => {

        const { apol, authorization } = this.props;
        const { id } = this.state;
        this.setState({ graphqlPending: true });

        try {
            await apol.mutate({
                mutation: mutationDeleteUserProfile,
                variables: {
                    input: authorization,
                    id
                },
                refetchQueries: [{
                    query: queryGetConfigData,
                    variables: { auth: authorization },
                }],
            });
            toast.success('Profile deleted', {
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
        } catch (error) {
            toast.error('Error deleting profile', {
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
        }
        setTimeout(() => this.setState({ graphqlPending: false }), 1000);

        this.props.closePanel();

    }

    handleAddExistingRule = () => {
        const { selectedRule, rules } = this.state;
        const profileRulesData = this.props.profileRulesData || [];
        const filteredRuleData = (this.props.ruleData || []).filter(rule => rule.group === "recording");
        const profileRules = [...profileRulesData, ...filteredRuleData];

        if (selectedRule) {
            const ruleToAdd = profileRules.find(rule => rule.id === selectedRule);
            if (ruleToAdd) {
                this.setState({ rules: [...rules, ruleToAdd], selectedRule: null, updated: true }, this.validateForm);
            }
        }
    };
    //this function will be passed to profileuleSettings to get triggered on create new rule from button
    handleAddOrEditRuleFromProfile = (rule) => {
        if (rule && rule.id) {
            const existingRuleIndex = this.state.rules.findIndex(r => r.id === rule.id);
            if (existingRuleIndex !== -1) {
                const updatedRules = [...this.state.rules];
                updatedRules[existingRuleIndex] = rule;
                this.setState({ rules: updatedRules, updated: true }, this.validateForm);
            } else {
                this.setState({ rules: [...this.state.rules, rule], updated: true }, this.validateForm);
            }
        }
    };
    handleRuleSelection = (event, option) => {
        this.setState({ selectedRule: option.key });
    };
    onChangeReasonsInput = (event, stateKey, placeholderKey) => {
        const inputValue = event.target.value;
        const values = inputValue.split('|');

        if (values.length <= 10) {
            this.setState({
                [stateKey]: inputValue,
                [placeholderKey]: "stopReasonsDescription",
                updated: true
            },
                this.validateForm);
        } else {
            this.setState({ [placeholderKey]: "maxLimitReasons" })
        }
    }

    // ANNOUNCEMENTS FUNCTIONS
    onUpdatedAnnouncement = (i, announcement, prevFile) => {
        if (this.state.announcements.length > i) {
            const updatedAnnouncements = this.state.announcements.map((item, index) => (index !== i ? item : announcement));
            this.updateState("announcements", updatedAnnouncements);
        } else {
            var announcements = this.state.announcements;
            announcements.push(announcement);

            this.updateState("announcements", announcements);
        }
        if (prevFile !== undefined && prevFile !== "") {
            let deletedFiles = this.state.deletedFilesFromAnnouncements;
            deletedFiles.push(prevFile);
            this.updateState("deletedFilesFromAnnouncements", deletedFiles);
        }
    };

    onDeleteAnnouncement = (i, defaultAnn) => {
        let deletedFiles = this.state.deletedFilesFromAnnouncements;

        if (defaultAnn) {
            let annDefault = this.state.defaultAnnouncement;

            if (annDefault !== null && annDefault !== undefined && annDefault.start !== "") {
                deletedFiles.push(annDefault.start);
            }
            if (annDefault !== null && annDefault !== undefined && annDefault.stop !== "") {
                deletedFiles.push(annDefault.stop);
            }

            var defAnnouncementEmpty = {
                prefixList: ["default"],
                start: "",
                stop: "",
            };

            if (this.state !== undefined && this.state !== null) {
                this.updateState("defaultAnnouncement", defAnnouncementEmpty);
                this.updateState("deletedFilesFromAnnouncements", deletedFiles);
            }
        } else {
            var announcements = this.state.announcements;

            //create an array with deleted files from deleted announcements
            //this helps in case user deletes an announcement but the doesn't click save
            //files will be deleted only after pressing save to make sure files are not lost if canceled
            if (announcements[i] !== null && announcements[i] !== undefined && announcements[i].start !== "") {
                deletedFiles.push(announcements[i].start);
            }
            if (announcements[i] !== null && announcements[i] !== undefined && announcements[i].stop !== "") {
                deletedFiles.push(announcements[i].stop);
            }

            //remove announcement from list
            announcements.splice(i, 1);
            if (this.state !== undefined && this.state !== null) {
                this.updateState("announcements", announcements);
                this.updateState("numberPrefixIndex", this.state.numberPrefixIndex - 1);
                this.updateState("deletedFilesFromAnnouncements", deletedFiles);
            }
        }
    };

    uploadToDefault = (file, type) => {
        var ann = this.state.defaultAnnouncement;
        let prevFile = "";
        let deletedFiles = this.state.deletedFilesFromAnnouncements;
        if (type === "Start") {
            prevFile = ann.start;
            ann.start = file;
        } else if (type === "Stop") {
            prevFile = ann.stop;
            ann.stop = file;
        }
        if (prevFile !== undefined && prevFile !== "") {
            deletedFiles.push(prevFile);
        }
        this.updateState("defaultAnnouncement", ann);
        this.updateState("deletedFilesFromAnnouncements", deletedFiles);
    };


    // -----------------------------------------------------------------------------------------------------------------------------------------------

    render() {
        const profileRules = this.props.profileRulesData || []; //only new profile rules will be used. Will not get mixed with old rules
        const selectedRuleIds = this.state.rules.map(rule => rule.id);
        const availableRules = profileRules.filter(rule => {
            if (selectedRuleIds.includes(rule.id)) return false;
            if (this.state.isEntryVoiceOnly) {
                return rule.isEntryVoiceOnly === true;
            }
            return !rule.isEntryVoiceOnly;
        });

        const isSaveButtonDisabled =
            !this.state.isFormValid ||
            !this.state.updated ||
            this.props.accessProfiles === false ||
            this.state.graphqlPending
        const dtmfErrors = this._dtmfErrors || {};
        const disableNextRecordingReasonsError = this._disableNextRecordingReasonsError || "";
        return (
            <MyContext.Consumer>
                {context => (
                    <div className="container">

                        {/*----------------Rule used by-------------------------*/}
                        <div>
                            {this.tmpUserUsage.length > 0 && <Link onClick={() => this._openModal("users")}>{window.innerWidth < 600 ? "Exp" : context.getTranslation("configuration", "ruleUsedBy") + this.tmpUserUsage.length + context.getTranslation("configuration", "users")}</Link>}
                            <br />
                            {this.tmpGroupUsage.length > 0 && <Link onClick={() => this._openModal("groups")}>{window.innerWidth < 600 ? "Exp" : context.getTranslation("configuration", "ruleUsedBy") + this.tmpGroupUsage.length + " groups"}</Link>}
                            <Modal
                                id="usersList"
                                isOpen={this.state.showModal}
                                onDismiss={this._closeModal}
                                isBlocking
                            >
                                <div className={classNames.listHeader}>
                                    {this.state.modalDisplay === "users"
                                        ? (
                                            <span><b>{context.getTranslation("configuration", "ruleUsedBy") + this.tmpUserUsage.length + context.getTranslation("configuration", "users")}</b></span>

                                        ) : (
                                            <span><b>{context.getTranslation("configuration", "ruleUsedBy") + this.tmpGroupUsage.length + " groups"}</b></span>

                                        )}


                                    <IconButton
                                        iconProps={{ iconName: 'Cancel' }}
                                        ariaLabel="Close popup modal"
                                        onClick={this._closeModal}
                                        styles={classNames.iconButtonStyles}

                                    />
                                </div>
                                <div className={classNames.listContent}>
                                    {this.state.modalDisplay === "users"
                                        ? (
                                            <Stack verical styles={classNames.listStyles}>
                                                {this.displayUsers.map((user) => <div key={user.userid}>
                                                    <div className={classNames.userList}><mgt-person key={user.userid} show-name={true} user-id={user.userid} person-card="hover"></mgt-person></div>
                                                    <div className={classNames.userList}><span className={classNames.userNameAlign}>{user.name}</span></div>
                                                </div>
                                                )}
                                            </Stack>
                                        ) : (
                                            <Stack verical styles={classNames.listStyles}>
                                                {this.displayGroups.map((group) => <div key={group.id}>
                                                    <Persona
                                                        key={group.id}
                                                        size={PersonaSize.size32}
                                                        id={group.id}
                                                        text={group.name}
                                                        className={classNames.groupList}
                                                    />
                                                </div>
                                                )}
                                            </Stack>
                                        )
                                    }
                                </div>
                            </Modal>
                        </div>
                        {/*-----------------------------------------*/}
                        <TextField
                            name="name"
                            label={context.getTranslation("configuration", "name")}
                            value={this.state.name}
                            onChange={this.handleInputChange}
                            errorMessage={this.state.nameError ? context.getTranslation("common", this.state.nameError) : ""}
                            required />

                        {/*entry voice checkobox is displayed on if tenant has an active entry voice license and if checked restrics rule only to users with this license*/}
                        {(this.props.tenantData?.licenseEntryVoiceRecording?.bought > 0 || this.props.profileData?.isEntryVoiceOnly) && <div>
                            <hr />
                            <Checkbox
                                label={context.getTranslation("configuration", "isEntryVoiceOnly")}
                                checked={this.state.isEntryVoiceOnly}
                                onChange={(event, newValue) => {

                                    this.setState({
                                        isEntryVoiceOnly: newValue,
                                        chatTtl: newValue ? 180 : this.state.chatTtl,
                                        rules: [],
                                        selectedRule: null,
                                        updated: true
                                    }, this.validateForm);
                                }}
                                disabled={this.props.profileData?.isEntryVoiceOnly}
                            />
                            <hr />
                        </div>}
                        <div style={{ display: 'flex', alignItems: 'center', marginBottom: 8 }}>
                            <Label style={{ marginRight: "5px" }}>{context.getTranslation("configuration", "selectRules")}</Label>
                            <TooltipHost content={context.getTranslation("recordingRule", "selectRuleTooltipText")}>
                                <FontIcon aria-label="Info" iconName="Info" style={{ cursor: 'pointer', fontSize: 14 }} />
                            </TooltipHost>
                        </div>
                        <div>
                            {this.state.rules.map((rule, index) => (
                                <RuleCard
                                    key={index}
                                    rule={rule}
                                    onMoveUp={() => this.moveRule(index, -1)}
                                    onMoveDown={() => this.moveRule(index, 1)}
                                    onDelete={() => this.deleteRule(index)}
                                    onEdit={() => this.openModalRule(rule.id)}
                                    isFirst={index === 0}
                                    isLast={index === this.state.rules.length - 1}
                                    context={context}
                                />
                            ))}
                        </div>
                        <div className="inline-fields">
                            <Dropdown
                                placeholder={context.getTranslation("configuration", "selectExistingRule")}
                                className="inline-field"
                                options={availableRules.map(rule => ({ key: rule.id, text: rule.name }))}
                                onChange={this.handleRuleSelection}
                                selectedKey={this.state.selectedRule}
                                disabled={availableRules.length === 0}
                            />
                            <PrimaryButton
                                text={context.getTranslation("configuration", "addRule")}
                                onClick={this.handleAddExistingRule}
                                disabled={!this.state.selectedRule}
                            />
                            <span className="or-text">{context.getTranslation("common", "or")}</span>
                            <PrimaryButton
                                text={context.getTranslation("configuration", "createNewRule")}
                                iconProps={{ iconName: 'Add' }}
                                onClick={this.openModalRule}
                                disabled={!this.props.accessProfiles}
                            />
                        </div>
                        <div style={{ marginTop: "3px" }}>
                            <div style={{ display: 'flex', alignItems: 'center', marginBottom: 8 }}>
                                <Label style={{ marginRight: "5px" }} required={this.state.timezoneRequired}>
                                    {context.getTranslation("configuration", "timezone")}
                                </Label>
                                <TooltipHost content={context.getTranslation("recordingRule", "timezoneTooltipText")}>
                                    <FontIcon aria-label="Info" iconName="Info" style={{ cursor: 'pointer', fontSize: 14 }} />
                                </TooltipHost>
                            </div>
                            <ComboBox
                                style={{ width: "250px" }}
                                name="timezone"
                                selectedKey={this.state.timezone}
                                options={this.state.timezonesList.map((tz) => ({ key: tz.id, text: tz.displayName }))}
                                onChange={(event, newValue) => {
                                    this.updateState("timezone", newValue.key);
                                }}
                                placeholder={context.getTranslation("recordingRule", "selectTimezone")}
                                errorMessage={
                                    this.state.timezoneRequired && (!this.state.timezone || this.state.timezone === "")
                                        ? context.getTranslation("recordingRule", "timezoneRequired")
                                        : ""
                                }
                                required={this.state.timezoneRequired}
                            />
                        </div>
                        <br />
                        <hr />
                        <br />

                        <div>
                            <Checkbox
                                label={context.getTranslation("configuration", "reevaluateCallWhenChange1:1ToMeeting")}
                                name="recReevaluateChangeFromOneToOneToMeeting"
                                checked={this.state.recReevaluateChangeFromOneToOneToMeeting}
                                onChange={this.handleCheckboxChange}
                            />

                            <Checkbox
                                label={context.getTranslation("configuration", "disableRecordingOnceForOutgoingConv")}
                                name="disableNextRecording"
                                checked={this.state.disableNextRecording}
                                onChange={this.handleCheckboxChange}
                            />
                            {this.state.disableNextRecording && <div style={{ marginLeft: "25px" }}
                            >
                                <Checkbox
                                    label={context.getTranslation("configuration", "disableNextRecordingReasonRequired")}
                                    name="disableNextRecordingReasonRequired"
                                    checked={this.state.disableNextRecordingReasonRequired}
                                    onChange={this.handleCheckboxChange}

                                />

                                {this.state.disableNextRecordingReasonRequired && <>
                                    <TextField
                                        value={this.state.disableNextRecordingReasons}
                                        onChange={(event) => this.onChangeReasonsInput(event, "disableNextRecordingReasons", "disableNextRecordingReasonsPlaceholder")}
                                        placeholder={context.getTranslation("recordingRule", "stopReasonsDescription")}
                                        errorMessage={disableNextRecordingReasonsError ? context.getTranslation("recordingRule", disableNextRecordingReasonsError) : ""}
                                    />
                                    <span>{context.getTranslation("recordingRule", this.state.disableNextRecordingReasonsPlaceholder)}</span>
                                </>
                                }
                            </div>
                            }

                            <Checkbox
                                label={context.getTranslation("configuration", "recordUserStreamOnly")}
                                name="userStreamOnly"
                                checked={this.state.userStreamOnly}
                                onChange={this.handleCheckboxChange}
                            />
                            <Stack horizontal verticalAlign="center">
                                <Checkbox
                                    label={context.getTranslation("configuration", "recordSeparateSpeakers")}
                                    name="recordSeparateSpeakers"
                                    checked={this.state.recordSeparateSpeakers}
                                    onChange={this.handleCheckboxChange}

                                />
                                <TooltipHost content={context.getTranslation("configuration", "recordSeparateSpeakersInfoText")}>
                                    <FontIcon aria-label="Info" iconName="Info" style={{ cursor: 'pointer', fontSize: 14, marginLeft: 5 }} />

                                </TooltipHost>
                            </Stack>

                            <Checkbox
                                label={context.getTranslation("configuration", "delegationFeature")}
                                name="useOnBehalfOfUserSetting"
                                checked={this.state.useOnBehalfOfUserSetting}
                                onChange={this.handleCheckboxChange}
                            />
                            <Stack horizontal verticalAlign="center" className="cqRuleOverrideRowProfile">
                                <Checkbox
                                    label={context.getTranslation("configuration", "callQueueRuleOverride")}
                                    name="callQueueRuleOverride"
                                    checked={this.state.callQueueRuleOverride}
                                    onChange={this.handleCheckboxChange}
                                />
                                <TooltipHost content={<>{context.getTranslation("configuration", "callQueueRuleOverrideInfoText")}<br />{context.getTranslation("configuration", "callQueueRuleOverridePrerequisiteText")}</>} directionalHint={DirectionalHint.topLeftEdge} calloutProps={{ target: ".cqRuleOverrideRowProfile .ms-Checkbox-text", isBeakVisible: true, styles: { beak: { left: beakLeftOverIcon(".cqRuleOverrideRowProfile") } } }}>
                                    <FontIcon aria-label="Info" iconName="Info" style={{ cursor: 'pointer', fontSize: 14, marginLeft: 5 }} />
                                </TooltipHost>
                            </Stack>
                            <Checkbox
                                label={context.getTranslation("configuration", "onDemandDecisionTracking")}
                                name="trackOnDemandDecision"
                                checked={this.state.trackOnDemandDecision}
                                onChange={this.handleCheckboxChange}

                            />
                            <Checkbox
                                label={context.getTranslation("configuration", "ruleDecisionTracking")}
                                name="ruleDecisionTracking"
                                checked={this.state.ruleDecisionTracking}
                                onChange={this.handleCheckboxChange}

                            />

                            <Checkbox
                                label={context.getTranslation("configuration", "dtmfSettings")}
                                name="hasDtmfSettings"
                                checked={this.state.hasDtmfSettings}
                                onChange={this.handleCheckboxChange}
                            />
                            {this.state.hasDtmfSettings && (
                                <div className="indent">
                                    <Checkbox
                                        label={context.getTranslation("configuration", "rodControlViaDTMF")}
                                        name="isDtmfEnabled"
                                        checked={this.state.isDtmfEnabled}
                                        onChange={this.handleCheckboxChange}

                                    />
                                    <div>
                                        <p className="display-inline" style={{ marginRight: "10px", marginLeft: "28px" }}>{context.getTranslation("configuration", "rodStartCode")}</p>
                                        <TextField type={"text"}
                                            placeholder="0-9*#"
                                            value={this.state.rodDmtfSTart}
                                            onChange={(event, newValue) => {
                                                this.setState({
                                                    rodDmtfSTart: newValue,
                                                    updated: true
                                                },
                                                    this.validateForm);
                                            }}
                                            className="display-inline"
                                            disabled={!this.state.isDtmfEnabled}
                                            errorMessage={dtmfErrors.rodDmtfStartError ? context.getTranslation("recordingRule", dtmfErrors.rodDmtfStartError) : ""}
                                        />
                                    </div>
                                    <div>
                                        <p className="display-inline" style={{ marginRight: "10px", marginLeft: "28px" }}>{context.getTranslation("configuration", "rodStopCode")}</p>
                                        <TextField type={"text"}
                                            placeholder="0-9*#"
                                            value={this.state.rodDmtfStop}
                                            onChange={(event, newValue) => {
                                                this.setState({
                                                    rodDmtfStop: newValue,
                                                    updated: true
                                                },
                                                    this.validateForm);
                                            }}
                                            className="display-inline"
                                            disabled={!this.state.isDtmfEnabled}
                                            errorMessage={dtmfErrors.rodDmtfStopError ? context.getTranslation("recordingRule", dtmfErrors.rodDmtfStopError) : ""}
                                        />
                                    </div>
                                    <Checkbox
                                        label={context.getTranslation("configuration", "announcementsuppressionViaDtmfCode")}
                                        checked={this.state.isDtmfAnnouncementSuppressionEnabled}
                                        onChange={(event, newValue) => {
                                            this.setState({
                                                isDtmfAnnouncementSuppressionEnabled: newValue,
                                                updated: true
                                            }, this.validateForm);
                                        }}
                                    />
                                    <div>
                                        <p className="display-inline" style={{ marginRight: "10px", marginLeft: "28px" }}>{context.getTranslation("configuration", "suppressionCode")}</p>
                                        <TextField type={"text"}
                                            placeholder="0-9*#"
                                            value={this.state.announcementSuppressionCode}
                                            onChange={(event, newValue) => {
                                                this.setState({
                                                    announcementSuppressionCode: newValue,
                                                    updated: true
                                                },
                                                    this.validateForm);
                                            }}
                                            className="display-inline"
                                            disabled={!this.state.isDtmfAnnouncementSuppressionEnabled}
                                            errorMessage={dtmfErrors.announcementSuppressionCodeError ? context.getTranslation("recordingRule", dtmfErrors.announcementSuppressionCodeError) : ""}
                                        />
                                    </div>
                                    <div>
                                        <p className="display-inline" style={{ marginRight: "10px", marginLeft: "30px" }}>{context.getTranslation("configuration", "suppressionDays")}</p>
                                        <TextField type={"number"}
                                            value={this.state.announcementSuppressionTimeInDays}
                                            onChange={(event, newValue) => {
                                                this.setState({
                                                    announcementSuppressionTimeInDays: parseInt(newValue),
                                                    updated: true
                                                },
                                                    this.validateForm);
                                            }}
                                            className="display-inline"
                                            disabled={!this.state.isDtmfAnnouncementSuppressionEnabled}
                                            min={0}
                                            errorMessage={dtmfErrors.announcementSuppressionDaysError ? context.getTranslation("recordingRule", dtmfErrors.announcementSuppressionDaysError) : ""}
                                        />
                                    </div>
                                </div>
                            )}

                            <Checkbox
                                label={context.getTranslation("configuration", "chatRecording")}
                                name="chat"
                                checked={this.state.chat}
                                onChange={this.handleCheckboxChange}
                            />
                            {this.state.chat && (
                                <div className="indent">
                                    <Label>{context.getTranslation("configuration", "chatConversations")}</Label>
                                    <ChoiceGroup
                                        name="chatType"
                                        selectedKey={this.state.chatType}
                                        onChange={this.handleRadioChange}
                                        options={[
                                            {
                                                key: 'Bulk',
                                                text: context.getTranslation("configuration", "bulkRecording"),
                                                'data-automation-id': 'auto1',
                                                styles: { field: { fontWeight: FontWeights.regular } }
                                            },
                                            {
                                                key: 'Sync',
                                                text: (
                                                    <span style={{ display: 'inline-flex', alignItems: 'center' }}>
                                                        {context.getTranslation("configuration", "recordLikeAudioVideo")}
                                                        <TooltipHost content={context.getTranslation("recordingRule", "recordLikeAudioVideoInfoText")}>
                                                            <FontIcon aria-label="Info" iconName="Info" style={{ cursor: 'pointer', fontSize: 14, marginLeft: 5 }} />
                                                        </TooltipHost>
                                                    </span>
                                                ),
                                                disabled: !Array.isArray(this.state.rules) || this.state.rules.length === 0,
                                                styles: { field: { fontWeight: FontWeights.regular } }
                                            },
                                            {
                                                key: 'SyncExternal',
                                                text: (
                                                    <span style={{ display: 'inline-flex', alignItems: 'center' }}>
                                                        {context.getTranslation("configuration", "recChatSyncExternal")}
                                                        <TooltipHost content={context.getTranslation("recordingRule", "recChatSyncExternalInfoText")}>
                                                            <FontIcon aria-label="Info" iconName="Info" style={{ cursor: 'pointer', fontSize: 14, marginLeft: 5 }} />
                                                        </TooltipHost>
                                                    </span>
                                                ),
                                                disabled: !Array.isArray(this.state.rules) || this.state.rules.length === 0,
                                                styles: { field: { fontWeight: FontWeights.regular } }
                                            },
                                            {
                                                key: 'External',
                                                text: context.getTranslation("configuration", "recChatExternal"),
                                                styles: { field: { fontWeight: FontWeights.regular } }
                                            }
                                        ]}
                                    />
                                    <Label>{context.getTranslation("configuration", "chatInChannel")}</Label>
                                    <ChoiceGroup
                                        name="channelType"
                                        selectedKey={this.state.channelType}
                                        onChange={this.handleRadioChange}
                                        options={[
                                            {
                                                key: 'Never',
                                                text: context.getTranslation("configuration", "neverRecord"),
                                                'data-automation-id': 'auto1',
                                                styles: { field: { fontWeight: FontWeights.regular } }
                                            },
                                            {
                                                key: 'Internal',
                                                text: context.getTranslation("configuration", "recChannelInternal"),
                                                styles: { field: { fontWeight: FontWeights.regular } }
                                            },
                                            {
                                                key: 'External',
                                                text: context.getTranslation("configuration", "recChannelExternal"),
                                                styles: { field: { fontWeight: FontWeights.regular } }
                                            },
                                            {
                                                key: 'Select',
                                                text: context.getTranslation("configuration", "recChannelSelect"),
                                                styles: { field: { fontWeight: FontWeights.regular } }
                                            },
                                            {
                                                key: 'Bulk',
                                                text: context.getTranslation("configuration", "bulkRecording"),
                                                styles: { field: { fontWeight: FontWeights.regular } }
                                            }
                                        ]}
                                    />
                                    {this.state.channelType === 'Select' && (
                                        <div>
                                            <Checkbox
                                                label={context.getTranslation("configuration", "internalParticipants")}
                                                name="internalParticipants"
                                                checked={this.state.internalParticipants}
                                                onChange={this.handleCheckboxChange}
                                            />

                                            <Checkbox
                                                label={context.getTranslation("configuration", "externalParticipants")}
                                                name="externalParticipants"
                                                checked={this.state.externalParticipants}
                                                onChange={this.handleCheckboxChange}
                                            />

                                            <Checkbox
                                                label={context.getTranslation("configuration", "recChannelSelect")}
                                                name="selectedChannel"
                                                checked={this.state.selectedChannel}
                                                onChange={this.handleCheckboxChange}
                                            />
                                            {this.state.selectedChannel && (
                                                <TextField
                                                    name="channelList"
                                                    className="indent"
                                                    placeholder={context.getTranslation("configuration", "recChannelListPlaceholder")}
                                                    value={this.state.channelList}
                                                    onChange={this.handleInputChange}
                                                    errorMessage={this.state.channelListError ? context.getTranslation("recordingRule", "channelListRequired") : ""}
                                                    required
                                                />
                                            )}
                                        </div>
                                    )}
                                    {/*will be used on a later feature*/}
                                    {/*<Checkbox*/}
                                    {/*    label={context.getTranslation("configuration", "announcementInChat")}*/}
                                    {/*    name="announcementInChat"*/}
                                    {/*    checked={this.state.announcementInChat}*/}
                                    {/*    onChange={this.handleCheckboxChange}*/}
                                    {/*/>*/}

                                    <Checkbox
                                        name="chatTypeDeny"
                                        label={context.getTranslation("configuration", "recChatTypeDeny")}
                                        checked={this.state.chatTypeDeny}
                                        className={classNames.marginTop}
                                        onChange={this.handleCheckboxChange}

                                    />
                                    {this.state.chatTypeDeny && <div className="indent">
                                        <Label variant="large" block>{context.getTranslation("configuration", "recordDenylistItems")}</Label>
                                        <UserPicker
                                            user={this.state.chatTypeDenyList}
                                            isAllowList={true}
                                            fc={(user) => {
                                                this.setState({
                                                    chatTypeDenyList: user,
                                                    updated: true
                                                }, this.validateForm);
                                            }}
                                        />
                                        {this.state.chatTypeDenyListError && (
                                            <span className="user-picker-error">
                                                {context.getTranslation("recordingRule", "chatTypeDenyListRequired")}
                                            </span>
                                        )}
                                    </div>}

                                    <div className={`${classNames.flexContainer} ${classNames.marginTop}`}>

                                        <p style={{ marginRight: "10px" }}>{context.getTranslation("recordingRule", "retentionTime")} </p>
                                        <TextField
                                            name="chatTtl"
                                            value={this.state.chatTtl}
                                            className={classNames.numberInput}
                                            type={"number"}
                                            min={0}
                                            max={(this.props.userRules?.license === "13" || this.state.isEntryVoiceOnly) ? 180 : undefined}
                                            errorMessage={
                                                this.state.chatTtl === 0
                                                    ? context.getTranslation("common", "minValue")
                                                    : ((this.props.userRules?.license === "13" || this.state.isEntryVoiceOnly) && this.state.chatTtl > 180)
                                                        ? "Maximum 180 days allowed"
                                                        : ""
                                            }
                                            onChange={(e, newValue) => {
                                                let limitedValue = parseInt(newValue);
                                                if ((this.props.userRules?.license === "13" || this.state.isEntryVoiceOnly) && limitedValue > 180) {
                                                    limitedValue = 180;
                                                }
                                                this.updateState("chatTtl", limitedValue);
                                            }}
                                        />
                                    </div>
                                </div>

                            )}

                            {/* EMAIL ARCHIVING is hidden for a different implementation/// Uncomment this section when needed
                                <Checkbox
                                label={context.getTranslation("configuration", "mailRecording")}
                                name="mail"
                                checked={this.state.mail}
                                onChange={this.handleCheckboxChange}
                            />
                            {this.state.mail && (
                                <div className="indent">
                                    <div className={`${classNames.flexContainer} ${classNames.marginTop}`}>
                                        <p style={{ marginRight: "10px" }}>{context.getTranslation("recordingRule", "retentionTime")} </p>
                                        <TextField
                                            name="mailTtl"
                                            value={this.state.mailTtl}
                                            className={classNames.numberInput}
                                            type={"number"}
                                            min={0}
                                            errorMessage={
                                                this.state.mailTtl === 0
                                                    ? context.getTranslation("common", "minValue")
                                                    : ""
                                            }
                                            onChange={(e, newValue) => {
                                                this.updateState("mailTtl", parseInt(newValue));
                                            }}
                                        />
                                    </div>
                                </div>
                            )}

                            */}

                            {/*announcements*/}

                            <div >

                                <Label variant="large" block>{context.getTranslation("recordingRule", "announcement")}</Label>


                                <ChoiceGroup
                                    name="announcementSetting"
                                    defaultSelectedKey={this.state.announcementSetting}
                                    className={classNames.marginBottom}
                                    options={[
                                        {
                                            key: "DefaultMsft",
                                            text: context.getTranslation("configuration", "microsoftDefault"),
                                            styles: { field: { fontWeight: FontWeights.regular } },
                                        },
                                        {
                                            key: "PstnAnnouncement",
                                            text: context.getTranslation("configuration", "pstnAnnouncement"),
                                            styles: { field: { fontWeight: FontWeights.regular } },
                                        },
                                        {
                                            key: "SilentRecording",
                                            text: context.getTranslation("configuration", "noAnnouncement"),
                                            styles: { field: { fontWeight: FontWeights.regular } },
                                        }
                                    ]}
                                    onChange={this.handleRadioChange}

                                />
                                {this.state.announcementSetting === "PstnAnnouncement" && (
                                    <div style={{ marginLeft: "30px" }}>
                                        <ChoiceGroup
                                            selectedKey={this.state.announcementType}
                                            style={{ width: "300px" }}
                                            name="announcementType"
                                            options={[
                                                {
                                                    key: "DefaultAnnouncement",
                                                    text: context.getTranslation("configuration", "RIDefaultAnnouncement"),
                                                    "data-automation-id": "auto1",
                                                    styles: { field: { fontWeight: FontWeights.regular } },
                                                },
                                                {
                                                    key: "CustomAnnouncement",
                                                    text: context.getTranslation("configuration", "customAnnouncement"),
                                                    styles: { field: { fontWeight: FontWeights.regular } },
                                                },
                                            ]}
                                            onChange={this.handleRadioChange}

                                        />
                                        {this.state.announcementType === "CustomAnnouncement" && (
                                            <div style={{ marginLeft: "30px" }}>
                                                {this.hasAnnouncementValidationError() && (
                                                    <MessageBar
                                                        messageBarType={MessageBarType.error}
                                                        isMultiline={false}
                                                        styles={{ root: { marginBottom: 16 } }}
                                                    >
                                                        {context.getTranslation("recordingRule", "pleaseUploadStartFile")}
                                                    </MessageBar>
                                                )}
                                                {this.state.announcements.map((item, key) => (
                                                    <NumberPrefix
                                                        id={key}
                                                        key={key}
                                                        announcement={item}
                                                        styles={styles}
                                                        deleteAnnouncement={this.onDeleteAnnouncement}
                                                        updateAnnouncement={this.onUpdatedAnnouncement}
                                                        authorization={this.props.authorization}
                                                        client={this.props.apol}
                                                    />
                                                ))}
                                                <CommandBarButton
                                                    style={{ padding: "5px 0px", marginBottom: "30px" }}
                                                    iconProps={{ iconName: "Add" }}
                                                    text={context.getTranslation("configuration", "addNumberPrefix")}
                                                    onClick={() => {
                                                        const newAnnouncement = { prefixList: [], start: "", stop: "" };
                                                        this.updateState("announcements", [...this.state.announcements, newAnnouncement]);
                                                    }}
                                                />
                                                <Checkbox
                                                    style={{ marginBottom: "200px !important" }}
                                                    name="defaultCustomAnnouncement"
                                                    className={classNames.marginBottom}
                                                    label={context.getTranslation("configuration", "defaultCustomAnnouncement")}
                                                    checked={this.state.defaultCustomAnnouncement}
                                                    onChange={this.handleCheckboxChange}

                                                />
                                                {this.state.defaultCustomAnnouncement && (
                                                    <div>
                                                        <div className={classNames.flexContainer} style={{ marginBottom: "5px" }}>
                                                            <IconButton
                                                                style={{ marginLeft: "-7px" }}
                                                                iconProps={{ iconName: "Delete" }}
                                                                onClick={() => {
                                                                    this.onDeleteAnnouncement("", true);
                                                                }}
                                                            />
                                                            <p style={{ marginTop: "10px" }}>{context.getTranslation("configuration", "removeAnnouncement")}</p>
                                                        </div>
                                                        <UploadAnnouncement
                                                            authorization={this.props.authorization}
                                                            apol={this.props.apol}
                                                            fileBtnText={this.state.defaultAnnouncement.start === "" ? "Start file" : this.state.defaultAnnouncement.start.slice(36)}
                                                            idResult="startResDef"
                                                            idError="startErrDef"
                                                            idFiles="startFileDef"
                                                            updateAnnouncement={this.uploadToDefault}
                                                            type="Start"
                                                            file={this.state.defaultAnnouncement.start}
                                                        />
                                                        <UploadAnnouncement
                                                            authorization={this.props.authorization}
                                                            apol={this.props.apol}
                                                            fileBtnText={this.state.defaultAnnouncement.stop === "" ? "Stop file" : this.state.defaultAnnouncement.stop.slice(36)}
                                                            idResult="stopResDef"
                                                            idError="stopErrDef"
                                                            idFiles="stopFileDef"
                                                            updateAnnouncement={this.uploadToDefault}
                                                            type="Stop"
                                                            file={this.state.defaultAnnouncement.stop}
                                                        />
                                                    </div>
                                                )}
                                            </div>
                                        )}
                                        <div style={{ marginTop: "15px" }}>
                                            <Checkbox
                                                label={context.getTranslation("configuration", "ascBeeptone")}
                                                checked={this.state.enableBeepTone}
                                                onChange={(event, newValue) => {
                                                    this.updateState("enableBeepTone", newValue);
                                                }}
                                            />
                                            <div style={{ display: "flex", marginLeft: "28px" }}>
                                                <span style={{ marginRight: "5px", marginTop: "5px" }}>{context.getTranslation("configuration", "repeatEvery")}</span>
                                                <TextField
                                                    type={"number"}
                                                    min={5}
                                                    className={classNames.numberInput}
                                                    value={this.state.beepToneDelay}
                                                    onChange={(event, newValue) => {
                                                        this.updateState("beepToneDelay", parseInt(newValue));
                                                    }}
                                                    disabled={!this.state.enableBeepTone}
                                                />
                                                <span style={{ marginLeft: "5px", marginTop: "5px" }}>{context.getTranslation("common", "seconds")}</span>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                        <TextField name="description" label={context.getTranslation("configuration", "description")} value={this.state.description} onChange={this.handleInputChange} multiline rows={3} />
                        <div className="buttons-container">
                            <div>
                                {this.state.showKeepDeleteConfirm && (
                                    <TeachingBubble
                                        target="#saveProfileBtn"
                                        hasCloseButton
                                        onDismiss={() => this.setState({ showKeepDeleteConfirm: false })}
                                        headline={context.getTranslation("common", "warning")}
                                        primaryButtonProps={{
                                            text: context.getTranslation("common", "save"),
                                            onClick: this.handleSave
                                        }}
                                        secondaryButtonProps={{
                                            text: context.getTranslation("common", "cancel"),
                                            onClick: () => this.setState({ showKeepDeleteConfirm: false })
                                        }}
                                    >
                                        <div style={{ marginBottom: '8px' }}>
                                            {context.getTranslation("recordingRule", "keepDeleteWarningText1")}
                                        </div>
                                        <div style={{ marginBottom: '8px' }}>
                                            {context.getTranslation("recordingRule", "keepDeleteWarningText2")}
                                        </div>
                                        <div style={{ marginLeft: '16px', marginBottom: '4px' }}>
                                            • {context.getTranslation("recordingRule", "keepDeleteWarningText3")}
                                        </div>
                                        <div style={{ marginLeft: '16px', marginBottom: '8px' }}>
                                            • {context.getTranslation("recordingRule", "keepDeleteWarningText4")}
                                        </div>
                                        <div>
                                            <strong>{context.getTranslation("common", "example")}:</strong> {context.getTranslation("recordingRule", "keepDeleteWarningText5")}
                                        </div>
                                    </TeachingBubble>
                                )}

                                <PrimaryButton
                                    id="saveProfileBtn"
                                    text={this.state.id ? context.getTranslation("common", "save") : context.getTranslation("common", "create")}
                                    onClick={() => { this.state.hasKeepDeleteRule && this.state.hasNoKeepDeleteRule ? this.setState({ showKeepDeleteConfirm: true }) : this.handleSave() }}
                                    disabled={isSaveButtonDisabled}
                                />
                                {(this.tmpUserUsage.length === 0 && this.tmpGroupUsage.length === 0) && (
                                    <>
                                        <DefaultButton
                                            id="deleteProfileBtn"
                                            onClick={() => this.setState({ showDeleteConfirm: true })}
                                            text={context.getTranslation("common", "delete")}
                                            className="delete-button button-spacing"
                                            disabled={this.props.accessProfiles === false || this.state.graphqlPending}
                                        />
                                        {this.state.showDeleteConfirm && (
                                            <TeachingBubble
                                                target="#deleteProfileBtn"
                                                hasCloseButton
                                                onDismiss={() => this.setState({ showDeleteConfirm: false })}
                                                headline={context.getTranslation("common", "confirmDelete")}
                                                primaryButtonProps={{
                                                    text: context.getTranslation("common", "delete"),
                                                    onClick: () => {
                                                        this.setState({ showDeleteConfirm: false });
                                                        this.deleteProfile();
                                                    },
                                                }}
                                                secondaryButtonProps={{
                                                    text: context.getTranslation("common", "cancel"),
                                                    onClick: () => this.setState({ showDeleteConfirm: false })
                                                }}
                                            >
                                                {context.getTranslation("recordingRule", "confirmDeleteProfile")}
                                            </TeachingBubble>
                                        )}
                                    </>
                                )}
                                <DefaultButton
                                    text={context.getTranslation("common", "close")}
                                    className="button-spacing"
                                    onClick={this.props.closePanel}
                                />
                            </div>
                        </div>
                        <Modal
                            isOpen={this.state.isModalOpen}
                            onDismiss={this.closeModal}
                            isBlocking={true}
                            containerClassName="modal-container"
                        >
                            <div className="modal-content-profile-rule">
                                <IconButton
                                    iconProps={{ iconName: 'Cancel' }}
                                    ariaLabel="Close"
                                    onClick={this.closeModal}
                                    style={{
                                        position: 'absolute',
                                        top: 8,
                                        right: 8,
                                        zIndex: 1
                                    }}
                                />
                                <ProfileRuleSettings
                                    apol={this.props.apol}
                                    authorization={this.props.authorization}
                                    profileRuleData={this.state.selectedRuleToEdit}
                                    handleAddOrEditRuleFromProfile={this.handleAddOrEditRuleFromProfile}
                                    ruleFromProfile={this.state.ruleFromProfile}
                                    tenantData={this.props.tenantData}
                                    closePanel={this.closeModal}
                                    profilesRuleList={this.props.profileRulesData}
                                    userRules={this.props.userRules}
                                />
                            </div>
                        </Modal>
                    </div>
                )}
            </MyContext.Consumer>
        );
    }
}

export default ProfileSettings;
